import { getHostName } from 'omni-package-react-cms';

export default function redirectToSearchPage(inputValue: string) {
  window.location.href = encodeURI(`${getHostName()}/cw/document-centre#q=${inputValue}`);
}
